import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";
//Import List
import DetailWorkstationList from "../../components/Lists/DetailWorkstation";
//Import actions redux
import { getWorkstations } from "../../store/actions";


class ProfileWorkstation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      wslist: null
    };
  }

  componentDidMount() {
    this.props.getWorkstations(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingGetWs === false && prevProps.loadingGetWs === true) {
      let ws = this.props.ws;
      if (ws) {
        this.prepareData(ws);
      }
    }
  }

  prepareData(ws){
    this.setState({wslist: ws})
  }


  render() {
    if (!this.state.wslist) {
      return (
        <React.Fragment>
        <div className="loaderCenter">
        <Loader></Loader>
        </div>
 
      </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Estado de estación de trabajo" breadcrumbItem="Detalle estación de trabajo" />
            <DetailWorkstationList />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetWs, loadingGetWs, ws, successWs } = state.GetWS;
  return { errorGetWs, loadingGetWs, ws, successWs };
};

export default withRouter(
  connect(mapStateProps, {
    getWorkstations,
  })(withNamespaces()(ProfileWorkstation))
);
